export const CompanyLocationData = {
    SET_COMPANYLOCATIONDATA: " SET_COMPANYLOCATIONDATA",
    ADD_COMPANYLOCATIONDATA: "ADD_COMPANYLOCATIONDATA",
    UPDATE_COMPANYLOCATIONDATA: "UPDATE_COMPANYLOCATIONDATA",
    DELETE_COMPANYLOCATIONDATA: "DELETE_COMPANYLOCATIONDATA",
   
}